(function () {
  var SOCIAL_ICONS = {
    instagram: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>',
    facebook: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>',
    twitter: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
    linkedin: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>',
    tiktok: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>',
    website: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>',
  };

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function parseList(raw) {
    if (!raw) return [];
    return raw.split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function isSafeUrl(url) {
    return url && /^https?:\/\//i.test(url);
  }

  function buildSocials(data) {
    var platforms = ['instagram', 'facebook', 'twitter', 'linkedin', 'tiktok', 'website'];
    return platforms
      .filter(function (p) { return isSafeUrl(data[p]); })
      .map(function (p) {
        var label = p.charAt(0).toUpperCase() + p.slice(1);
        return (
          '<a href="' + escapeHtml(data[p]) + '"' +
          ' class="people-modal__social-link"' +
          ' target="_blank" rel="noopener noreferrer"' +
          ' aria-label="' + label + '"' +
          ' role="listitem">' +
          (SOCIAL_ICONS[p] || '') +
          '</a>'
        );
      })
      .join('');
  }

  function populateModal(modal, card) {
    var d = card.dataset;
    var photo = modal.querySelector('.people-modal__photo');

    if (d.image) {
      photo.src = d.image;
      photo.alt = d.name || '';
      photo.style.display = '';
    } else {
      photo.src = '';
      photo.alt = '';
      photo.style.display = 'none';
    }

    modal.querySelector('.people-modal__name').textContent = d.name || '';
    modal.querySelector('.people-modal__role').textContent = d.role || '';
    modal.querySelector('.people-modal__bio').textContent = d.bio || '';
    modal.querySelector('.people-modal__socials').innerHTML = buildSocials(d);

    var awards = parseList(d.awards);
    var awardsWrap = modal.querySelector('.people-modal__awards-wrap');
    awardsWrap.hidden = awards.length === 0;
    modal.querySelector('.people-modal__awards').innerHTML = awards.map(function (a) {
      return '<li>' + escapeHtml(a) + '</li>';
    }).join('');

    var works = parseList(d.works);
    var worksWrap = modal.querySelector('.people-modal__works-wrap');
    worksWrap.hidden = works.length === 0;
    modal.querySelector('.people-modal__works').innerHTML = works.map(function (w) {
      return '<li>' + escapeHtml(w) + '</li>';
    }).join('');
  }

  function openModal(modal, triggerCard) {
    modal.hidden = false;
    modal._trigger = triggerCard;
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('.people-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
    if (modal._trigger) {
      modal._trigger.focus();
      modal._trigger = null;
    }
  }

  function trapFocus(modal, e) {
    var focusable = Array.from(
      modal.querySelectorAll('button:not([disabled]), a[href]')
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    if (!track || !prevBtn || !nextBtn) return;

    function getStep() {
      var firstItem = track.querySelector('li');
      if (!firstItem) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return firstItem.getBoundingClientRect().width + gap;
    }

    function updateNav() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  document.querySelectorAll('.people-group[data-carousel]').forEach(initCarousel);

  document.querySelectorAll('.person-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var modal = document.getElementById(card.dataset.modal);
      if (!modal) return;
      populateModal(modal, card);
      openModal(modal, card);
    });
  });

  document.querySelectorAll('.people-modal').forEach(function (modal) {
    modal.querySelectorAll('[data-close-modal]').forEach(function (el) {
      el.addEventListener('click', function () { closeModal(modal); });
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeModal(modal); return; }
      if (e.key === 'Tab') trapFocus(modal, e);
    });
  });
})();
